import { AccessibilityViewIndex } from 'types/accessibilityViewIndex';

import { EditorSettingsState } from './editorSettingsSlice.types';

/**
 * Close all the right side menus in the editor.
 * Mutates the state.
 *
 * TODO - should consider consolidating the right side menus into a single component
 *  controlled by single state enum/string since only one can be open at a time.
 *
 * @param state Editor settings state to update
 */
export const closeAllRightSideMenus = (state: EditorSettingsState) => {
  state.accessibilityViewIndex = AccessibilityViewIndex.CLOSED;
  state.isSlideView = false;
  state.isWidgetSettingsView = false;
  state.editBackgroundView = undefined;
};
